import { useEffect, useState } from 'react';
import client from '../../api/client';

let cache = null;
let inflight = null;

export function useConsentTexts() {
  const [texts, setTexts] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || client.get('/legal/consent-texts').then(({ data }) => { cache = data; return data; });
    inflight.then(setTexts).catch(() => {});
  }, []);
  return texts;
}
